import type { ReportHistoryStatusUnionType } from '@api';

type GetReportHistoryStatusColorReturnType = {
  backgroundColor: string;
  textColor: string;
};

export const getReportHistoryStatusColor = (
  status: ReportHistoryStatusUnionType
): GetReportHistoryStatusColorReturnType => {
  switch (status) {
    case 'SENT':
      return { backgroundColor: '#C7F5D9', textColor: '#0C4121' };
    case 'READY_RESET':
      return { backgroundColor: '#FFDDB8', textColor: '#5C2C00' };
    case 'SKIPPED_NOT_READY':
      return { backgroundColor: '#E9ECEF', textColor: '#343A40' };
    case 'FAILED_GENERATION':
    case 'FAILED_SEND':
      return { backgroundColor: '#FFD6D6', textColor: '#5C0B0B' };
  }
};
